import {
	Ban,
	BookOpen,
	Building2,
	CircleHelp,
	Contact,
	Crosshair,
	Database,
	Feather,
	Globe,
	Inbox,
	LayoutDashboard,
	LayoutTemplate,
	LifeBuoy,
	LineChart,
	List,
	Megaphone,
	ListChecks,
	type LucideIcon,
	Puzzle,
	Rss,
	Send,
	Settings,
	ShieldBan,
	SlidersHorizontal,
	SquarePen,
	Star,
	Swords,
	Ticket,
	ToggleRight,
} from "lucide-react";

/**
 * Lucide monoline icon set for the nav-v7 sidebar redesign. Icons inherit their
 * colour from the surrounding nav row via `currentColor`, so the item component
 * controls muted / hover / active tinting — no separate `iconActive` is needed.
 */
const ICON_CLASS = "w-[19px] h-[19px] flex-shrink-0";

export const renderSidebarIcon = (SidebarIcon: LucideIcon): JSX.Element => (
	<SidebarIcon className={ICON_CLASS} strokeWidth={1.9} />
);

export const SidebarIcons = {
	dashboard: LayoutDashboard,
	compose: SquarePen,
	inbox: Inbox,
	outbox: Send,
	leadLists: List,
	campaigns: Megaphone,
	reviewLeads: ListChecks,
	contacts: Contact,
	profileTracker: Crosshair,
	feed: Rss,
	leadScoring: Star,
	signalScoring: SlidersHorizontal,
	knowledgeDb: Database,
	copywriting: Feather,
	templates: LayoutTemplate,
	analytics: LineChart,
	integrations: Puzzle,
	websites: Globe,
	doNotContact: ShieldBan,
	competitors: Swords,
	blacklist: Ban,
	globalBlacklist: Ban,
	companies: Building2,
	featureManagement: ToggleRight,
	supportDashboard: LifeBuoy,
	tickets: Ticket,
	companySettings: Settings,
	helpArticles: BookOpen,
} as const;
